(function () {
    'use strict';

    angular.module('app')
        .factory('Geonames', Geonames);

    // Ejemplo: http://iconclass.org/22C.json

    /* @ngInject */
    function Geonames($resource) {
        return $resource('api/geonames/:nombre', {}, {
            'get': {
                isArray: true
            }
        });
    }
})();
